<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Advarsler</mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        <dt>Advarsel om <b>Bevilget beløb</b> højere end <b>Ansøgt beløb</b></dt>
        <dd>{{form.controls.exceeding_grant_warning.value ? 'Ja' : 'Nej'}}</dd>
      </dl>
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" class="mb-3">
        <div fxFlex="45" fxLayout="column">
          <mat-checkbox ngDefaultControl formControlName="exceeding_grant_warning">Advarsel om <b>Bevilget beløb</b> højere end <b>Ansøgt beløb</b></mat-checkbox>
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="doCancel()">Fortryd</button>
        <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
